export default {
  path: '/profile_benchmarks',
  name: 'profile_benchmarks',
  component: () => import('../components/profilebenchmark/Layout'),
  redirect: { name: 'ProfileBenchmarkList' },
  meta: {
    breadcrumb: 'profile.score.benchmarks',
  },
  children: [
    {
      name: 'ProfileBenchmarkList',
      path: '',
      component: () => import('../views/profilebenchmark/List'),
      meta: {
        breadcrumb: 'global.list',
      },
    },
    {
      name: 'ProfileBenchmarkCreate',
      path: 'new',
      component: () => import('../views/profilebenchmark/Create'),
      meta: {
        breadcrumb: 'global.add',
      },
    },
    {
      name: 'ProfileBenchmarkUpdate',
      path: ':id/edit',
      component: () => import('../views/profilebenchmark/Update'),
      meta: {
        breadcrumb: 'profile.score.benchmark',
      },
    },
    {
      name: 'ProfileBenchmarkShow',
      path: ':id',
      component: () => import('../views/profilebenchmark/Show'),
      meta: {
        breadcrumb: 'profile.score.benchmark',
      },
    }
  ]
};
